import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles/createTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { usePageView } from 'src/hooks/use-page-view';
import { Seo } from '../seo';
import SuceessIcon from 'src/icons/untitled-ui/duocolor/success.svg';

const DocumentErrorPage = ({ errorInfo }: any) => {
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  usePageView();

  return (
    <>
      <Seo title="Error: Not Found" />
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 6,
            }}
          >
            <img
              alt="Not found"
              src={SuceessIcon}
              style={{
                height: 'auto',
                maxWidth: '30%',
                width: 120,
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '90%',
              }}
            >
              <Typography
                alignContent={'center'}
                variant="h5"
              >
                Hello{':)'} <br />
                Your patient data is saved! Please navigate to the patient’s episode of care to sign
                or continue editing the document.
                <br />
                <br />
                Thank you,
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6,
            }}
          >
            <Button
              onClick={() => (window.location.href = '/dashboard')}
              variant="outlined"
            >
              Back to Home
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default DocumentErrorPage;
